<template>
  <div class="flex h-full flex-col gap-5">
    <div>
      <h2 class="text-2xl font-bold">
        {{ $t('global.registered_not_yet_on_dashboard') }}
      </h2>
    </div>
    <div class="flex flex-1 flex-col gap-3 overflow-auto">
      <div class="grid w-full grid-cols-4 gap-3">
        <div class="flex flex-col rounded-md border p-2 shadow">
          <h4 class="shrink-0 truncate text-base font-medium">
            {{ $t('button.new_dashboard') }}
          </h4>
          <p class="text-sm">
            {{ $t('global.click_to_create_your_new_dashbaord') }}
          </p>
          <div class="flex flex-1 flex-row items-end">
            <div class="flex-1 text-right">
              <button
                type="button"
                class="rounded-md bg-green-500 px-1 py-0.5 text-white"
                @click="$emit('new-dashboard')"
              >
                {{ $t('button.create') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <template v-for="(groupedDashboard, idx) in groupedDashboards" :key="idx">
        <h2 class="text-lg font-bold">{{ groupedDashboard.label }}</h2>
        <div class="grid w-full grid-cols-4 gap-3">
          <template
            v-for="dashboard in groupedDashboard.dashboardList"
            :key="dashboard.id"
          >
            <div class="truncate rounded-md border p-2 shadow">
              <h4 class="text-base font-bold">
                {{ dashboard.name[$i18n.locale] }}
              </h4>
              <p
                v-if="
                  dashboard.description && dashboard.description[$i18n.locale]
                "
                class="text-sm"
              >
                {{ dashboard.description[$i18n.locale] }}
              </p>
              <div class="mt-1 flex flex-row items-end">
                <div class="flex-1">
                  <AvatarComponent :user_id="dashboard.creator_id" />
                </div>
                <div class="shrink-0">
                  <button
                    class="bg-primary-500 rounded-md px-1 py-0.5 text-white"
                    @click="handleSubscribe(dashboard.id)"
                  >
                    {{ $t('global.subscribe') }}
                  </button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AvatarComponent from '@c/AvatarComponent.vue'

export default {
  name: 'SelectPublicDashboard',
  components: { AvatarComponent },
  props: {
    typeDashboard: {
      type: Array,
      required: true
    },
    goToNewDashboard: {
      type: Function,
      required: false,
      default: () => (template_dashboard_id) => {
        console.log('You have to define method goToNewDashboard')
      }
    }
  },
  emits: ['new-dashboard'],
  data() {
    return {
      dashboardList: []
    }
  },
  computed: {
    ...mapGetters({
      myDashboardList: 'metadata/getTemplateDashboards',
      dashboardTypes: 'metadata/getTemplateDashboardTypes'
    }),
    groupedDashboards() {
      return this.dashboardTypes
        .filter(
          (item) => !this.typeDashboard || this.typeDashboard.includes(item.id)
        )
        .reduce((container, dashbordType) => {
          container.push({
            label: dashbordType.name,
            dashboardList: this.dashboardList.filter(
              (dashboard) => dashboard.type === dashbordType.id
            )
          })
          return container
        }, [])
        .filter((item) => item.dashboardList.length)
    }
  },
  mounted() {
    this.processFetchTemplateDashboardPublicAction().then(
      (response) => (this.dashboardList = response.data.template_dashboards)
    )
  },
  methods: {
    ...mapActions({
      processFetchTemplateDashboardPublicAction:
        'dashboard/fetchTemplateDashboardPublic',
      processRefreshSpecificInitialMetadataModelsAction:
        'metadata/refreshSpecificInitialMetadataModels',
      processSubscribeToTemplateDashboardAction:
        'dashboard/subscribeToTemplateDashboard'
    }),
    handleSubscribe(template_dashboard_id) {
      this.processSubscribeToTemplateDashboardAction({
        template_dashboard_id
      }).then((_response) =>
        this.processRefreshSpecificInitialMetadataModelsAction({
          model: 'template_dashboards'
        }).then((response) => {
          this.goToNewDashboard(template_dashboard_id)
        })
      )
    }
  }
}
</script>
